"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgLectern(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M15.243 16.85l2.487 6.094a.766.766 0 01-1.372.673l-.046-.094-2.724-6.673h-3.347l-2.723 6.673a.766.766 0 01-1.451-.48l.032-.099 2.487-6.094h-3.82a.766.766 0 01-.104-1.524l.104-.007h1.276V2.809c0-.388.289-.709.663-.76l.103-.006 4.34-.001V.766a.766.766 0 011.526-.104l.007.104-.001 1.276h4.341c.388 0 .708.289.76.663l.006.103V15.32h1.277a.766.766 0 01.104 1.525l-.104.007-3.821-.001zm1.012-13.276h-8.68L7.573 15.32h8.681V3.574z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgLectern;
exports.default = _default;